import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getBrandFeatures } from '@ibe/models/ui';
import { Observable, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { SidebarService } from '@ibe/services/ui';

@Component({
	selector: 'app-whats-included-brand',
	templateUrl: './whats-included-brand.component.html',
	styleUrls: ['./whats-included-brand.component.scss']
})
export class WhatsIncludedBrandComponent
	implements OnInit, OnDestroy {

	// Page status variables
	private isAlive: boolean;

	hasChanges$: Observable<any> = combineLatest(
		this.route.params
	);

	params: {
		brand?
	};

	// Data variables
	brand: any = null;
	brandFeatures = null;
	brandLabelsList = {
		discount: 'Discount',
		basic: 'Basic',
		classic: 'Classic',
		plus: 'Plus',
		executive: 'Executive',
		'top-executive': 'Top Executive',
	}

	scrollingTimeout;
	isScrolling = false;

	display: boolean = true;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected _http: HttpClient
	) {

	}

	async ngOnInit() {
		this.isAlive = true;

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([routeParms]) => {
				if (routeParms.brand) {
					this.brand = {
						id: routeParms.brand,
						label: this.brandLabelsList[routeParms.brand]
					};
					this.brandFeatures = getBrandFeatures(this.brand.id);
				}
			});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	/** Handles close action intention **/
	TAP_handleClose() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}
}
